module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/bottom-blob.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/bottom-blob.svg
// module id = 797
// module chunks = 5 6